import { render, staticRenderFns } from "./GameQuestionContainer.vue?vue&type=template&id=24e4371f&"
import script from "./GameQuestionContainer.vue?vue&type=script&lang=js&"
export * from "./GameQuestionContainer.vue?vue&type=script&lang=js&"
import style0 from "./GameQuestionContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e4371f')) {
      api.createRecord('24e4371f', component.options)
    } else {
      api.reload('24e4371f', component.options)
    }
    module.hot.accept("./GameQuestionContainer.vue?vue&type=template&id=24e4371f&", function () {
      api.rerender('24e4371f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GameQuestionContainer.vue"
export default component.exports